(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react")) : factory(root["react"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(2);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);var _shallowEquals=__webpack_require__(6);var _shallowEquals2=_interopRequireDefault(_shallowEquals);var _validate=__webpack_require__(7);var _style=__webpack_require__(8);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Slider=function(_Component){_inherits(Slider,_Component);function Slider(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Slider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Slider.__proto__||Object.getPrototypeOf(Slider)).call.apply(_ref,[this].concat(args))),_this),_this.state={percent:_this.props.defaultValue,hover:false,isActive:false},_this.getPercent=function(){var percent=_this._isControlled?_this.props.value:_this.state.percent;if(percent>100){return 100;}if(percent<0){return 0;}return percent;},_this.shouldUpdateState=function(ns,cs){return(0,_shallowEquals2.default)(ns,cs);},_this.shouldUpdateProps=function(np,cp){return(0,_shallowEquals2.default)(np,cp);},_this.shouldComponentUpdate=function(np,ns){return _this.shouldUpdateState(ns,_this.state)||_this.shouldUpdateProps(np,_this.props);},_this.onWindowResize=function(){_this._sliderWidth=_this._sliderRef.clientWidth;_this.forceUpdate();},_this.done=function(){_this.props.onDone(_this.getPercent());},_this.update=function(data){if((0,_validate.isNumber)(data.percent)&&data.percent!==_this.getPercent()){_this.props.onChange(data.percent);if(!_this._isControlled){_this.setState(data);}else{var percent=data.percent,nState=_objectWithoutProperties(data,['percent']);_this.setState(nState);}}},_this.onMouseUp=function(){_this.setState({isActive:false});_this.done();_this.removeDocumentMouseEventListeners();},_this.onMouseMove=function(e){e.preventDefault();var newSliderOffset=_this.calcNewSliderOffset(e.clientX,_this.sliderStartPos);var percent=_this.calcPercent(newSliderOffset);_this.update({percent:percent});},_this.onGrab=function(e){if(!(0,_validate.isValidButton)(e.button))return;var currentSliderOffset=_this.getCurrentSliderOffset();_this.sliderStartPos=_this.calcSliderStartPos(e.nativeEvent.clientX,currentSliderOffset);_this.setState({isActive:true});_this.removeDocumentMouseEventListeners();_this.addDocumentMouseEventListeners();},_this.onMouseDown=function(e){if(!(0,_validate.isValidButton)(e.button))return;_this.sliderStartPos=_this.calcSliderStartPos(e.nativeEvent.clientX,e.nativeEvent.offsetX);var newSliderOffset=_this.calcNewSliderOffset(e.clientX,_this.sliderStartPos);var percent=_this.calcPercent(newSliderOffset);_this.update({percent:percent,isActive:true});_this.removeDocumentMouseEventListeners();_this.addDocumentMouseEventListeners();},_this.calcSliderStartPos=function(clientOffsetX,offsetX){return clientOffsetX-offsetX;},_this.calcPercent=function(sliderOffset){return sliderOffset/_this._sliderWidth*100;},_this.getCurrentSliderOffset=function(){return _this.getPercent()/100*_this._sliderWidth;},_this.onMouseEnter=function(){_this.setState({hover:true});},_this.onMouseLeave=function(){_this.setState({hover:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Slider,[{key:'componentDidMount',value:function componentDidMount(){this._isControlled=this.props.value!==null;this._sliderWidth=this._sliderRef.clientWidth;this._document=this._sliderRef.ownerDocument;window.addEventListener('resize',this.onWindowResize);var _props=this.props,value=_props.value,defaultValue=_props.defaultValue;if(value>0||defaultValue>0){this.forceUpdate();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.removeDocumentMouseEventListeners();this.removeWindowListeners();}},{key:'removeWindowListeners',value:function removeWindowListeners(){this._sliderRef.addEventListener('resize',this.onWindowResize);}},{key:'addDocumentMouseEventListeners',value:function addDocumentMouseEventListeners(){this._document.addEventListener('mousemove',this.onMouseMove);this._document.addEventListener('mouseup',this.onMouseUp);}},{key:'removeDocumentMouseEventListeners',value:function removeDocumentMouseEventListeners(){this._document.removeEventListener('mousemove',this.onMouseMove);this._document.removeEventListener('mouseup',this.onMouseUp);}},{key:'calcNewSliderOffset',value:function calcNewSliderOffset(clientOffsetX,sliderStartPos){var offsetFromStart=clientOffsetX-sliderStartPos;if(offsetFromStart<0){return 0;}else if(offsetFromStart>this._sliderWidth){return this._sliderWidth;}return offsetFromStart;}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,onChange=_props2.onChange,onDone=_props2.onDone,displayThumb=_props2.displayThumb,thumbColor=_props2.thumbColor,shadowColor=_props2.shadowColor,sliderPathColor=_props2.sliderPathColor,rounded=_props2.rounded,style=_props2.style,restOfProps=_objectWithoutProperties(_props2,['onChange','onDone','displayThumb','thumbColor','shadowColor','sliderPathColor','rounded','style']);var _state=this.state,hover=_state.hover,isActive=_state.isActive;var translateThumb=function translateThumb(){return'translateX('+_this2.getPercent()/100*_this2._sliderWidth+'px)';};var scaleShadow=function scaleShadow(){return'scaleX('+_this2.getPercent()/100+')';};var showThumb=function showThumb(){return hover||isActive||displayThumb?'inline':'none';};var getRoundness=function getRoundness(){return rounded?'9999px':'0px';};var colors={path:sliderPathColor||'rgb(245, 245, 245)',shadow:shadowColor||'rgb(131, 213, 252)',thumb:thumbColor||'rgb(102, 202, 249)'};var sliderStyle={sliderWrapperStyle:_extends({},_style.sliderWrapper,style),pathStyle:_extends({},_style.sliderPath,{backgroundColor:colors.path,borderRadius:getRoundness()}),shadowStyle:_extends({},_style.sliderShadow,{transform:scaleShadow(),backgroundColor:colors.shadow,borderRadius:getRoundness()}),thumbStyle:_extends({},_style.thumb,{transform:translateThumb(),backgroundColor:colors.thumb,display:showThumb()})};return _react2.default.createElement('div',_extends({style:sliderStyle.sliderWrapperStyle},restOfProps,{onMouseEnter:this.onMouseEnter,onMouseLeave:this.onMouseLeave}),_react2.default.createElement('div',{style:_style.selectable,onMouseDown:this.onMouseDown},_react2.default.createElement('div',{style:sliderStyle.pathStyle},_react2.default.createElement('div',{style:sliderStyle.shadowStyle,ref:function ref(_ref2){_this2._sliderRef=_ref2;}}))),_react2.default.createElement('div',{style:sliderStyle.thumbStyle,onMouseDown:this.onGrab}));}}]);return Slider;}(_react.Component);Slider.propTypes={onChange:_propTypes2.default.func,onDone:_propTypes2.default.func,value:_propTypes2.default.number,defaultValue:_propTypes2.default.number,displayThumb:_propTypes2.default.bool,thumbColor:_propTypes2.default.string,shadowColor:_propTypes2.default.string,sliderPathColor:_propTypes2.default.string,rounded:_propTypes2.default.bool,style:_propTypes2.default.object};Slider.defaultProps={onDone:function onDone(){},onChange:function onChange(){},value:null,defaultValue:0,displayThumb:true,thumbColor:'',shadowColor:'',sliderPathColor:'',rounded:true,style:{}};exports.default=Slider;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(4)();
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(5);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};module.exports=function shallowEqual(objA,objB,compare,compareContext){var ret=compare?compare.call(compareContext,objA,objB):undefined;if(ret!==undefined){return!!ret;}if(objA===objB){return true;}if((typeof objA==='undefined'?'undefined':_typeof(objA))!=='object'||!objA||(typeof objB==='undefined'?'undefined':_typeof(objB))!=='object'||!objB){return false;}var keysA=Object.keys(objA);var keysB=Object.keys(objB);if(keysA.length!==keysB.length){return false;}var bHasOwnProperty=Object.prototype.hasOwnProperty.bind(objB);// Test for A's keys different from B.
for(var idx=0;idx<keysA.length;idx+=1){var key=keysA[idx];if(!bHasOwnProperty(key)){return false;}var valueA=objA[key];var valueB=objB[key];ret=compare?compare.call(compareContext,valueA,valueB,key):undefined;if(ret===false||ret===undefined&&valueA!==valueB){return false;}}return true;};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var isNumber=exports.isNumber=function isNumber(n){return!isNaN(parseFloat(n))&&isFinite(n);};var isValidButton=exports.isValidButton=function isValidButton(b){return b===0;};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var sliderWrapper=exports.sliderWrapper={cursor:'pointer',height:'13px',paddingLeft:'6px',paddingRight:'6px',textAlign:'left'};var selectable=exports.selectable={overflowY:'hidden',height:'100%',width:'100%'};var sliderPath=exports.sliderPath={marginTop:'4px',width:'100%',height:'5px',overflow:'hidden'};var sliderShadow=exports.sliderShadow={pointerEvents:'none',height:'100%',transformOrigin:'left'};var thumb=exports.thumb={position:'absolute',marginTop:'-12.5px',marginLeft:'-6px',width:'12px',height:'12px',borderRadius:'25px'};

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js